import { Device } from '../services/devices'
import type { KaseyaDevice } from '../services/kaseya-api'

export interface FormattedDevice {
  id: string
  deviceId: string
  name: string
  email: string
  organization: string
  tickets: number
  lastActive: string
  status: 'online' | 'offline' | 'warning' | 'error'
  osType: string
  deviceType: string
  source?: 'database' | 'kaseya'
}

// Helper function to format device data for display
export const formatDeviceForDisplay = (device: Device): FormattedDevice => ({
  id: device.id,
  deviceId: device.device_id_display || `DEV-${device.id.slice(-3).toUpperCase()}`,
  name: device.user_full_name || device.name,
  email: device.user_email || (device.user_id ? 'user@wcd.com' : '-'),
  organization: device.organization_name || 'Unknown',
  tickets: device.ticket_count || 0,
  lastActive: device.last_active ? new Date(device.last_active).toLocaleString() :
             (device.last_seen ? new Date(device.last_seen).toLocaleString() : 'Never'),
  status: device.status,
  osType: device.os_type || 'Unknown',
  deviceType: device.device_type_display || device.os_type || 'Unknown',
  source: 'database'
})

// Helper function to format Kaseya device data for display
export const formatKaseyaDeviceForDisplay = (device: KaseyaDevice): FormattedDevice => ({
  id: `kaseya-${device.Identifier}`,
  deviceId: device.Identifier,
  name: device.Name,
  email: '-',
  organization: device.OrganizationName || device.GroupName || 'Unknown',
  tickets: 0,
  lastActive: device.IsAgentInstalled ? 'Online' : 'Unknown',
  status: device.IsAgentInstalled ? 'online' : 'offline',
  osType: 'Unknown',
  deviceType: 'Kaseya Device',
  source: 'kaseya'
})
